import React, { useState } from 'react';
import { useDiscrete } from '../../contexts/DiscreteContext';

export const PromoComic = ({ imageSrc = '/promo_next_month.jpg', reverse = false }) => {
  const { discreteBlurStyle } = useDiscrete();
  const [imgError, setImgError] = useState(false);

  const flipAnimation = reverse
    ? 'promoGlow 4s ease-in-out infinite, cardFlipReverse 6s ease-in-out 2s infinite'
    : 'promoGlow 4s ease-in-out infinite, cardFlip 6s ease-in-out infinite';

  return (
    <div style={styles.promoCardWrapper}>
      <div style={{ ...styles.promoCard, animation: flipAnimation }} className="promo-card-flip">
        <div style={styles.promoSparkleContainer}>
          <div style={{...styles.promoSparkle, ...styles.promoSparkle1}}>✨</div>
          <div style={{...styles.promoSparkle, ...styles.promoSparkle2}}>⭐</div>
        </div>
        {imgError ? (
          <div style={styles.comingSoonPlaceholder}>
            <span style={styles.comingSoonIcon}>🎨</span>
            <span style={styles.comingSoonText}>Coming{'\n'}Soon</span>
          </div>
        ) : (
          <img
            src={imageSrc}
            alt="Coming Soon"
            style={{
              ...styles.promoCover,
              ...discreteBlurStyle,
              transition: 'filter 0.3s ease',
            }}
            onError={() => setImgError(true)}
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  promoCardWrapper: {
    perspective: '1000px',
    width: '100%',
    maxWidth: '200px',
  },
  promoCard: {
    width: '100%',
    maxWidth: '200px',
    backgroundColor: 'white',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(255, 215, 0, 0.3), 0 0 20px rgba(255, 215, 0, 0.2)',
    border: '3px solid rgba(255, 215, 0, 0.6)',
    position: 'relative',
    animation: 'promoGlow 4s ease-in-out infinite, cardFlip 6s ease-in-out infinite',
    transformStyle: 'preserve-3d',
  },
  promoCover: {
    width: '100%',
    aspectRatio: '2/3',
    objectFit: 'cover',
    display: 'block',
  },
  promoSparkleContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 1,
  },
  promoSparkle: {
    position: 'absolute',
    fontSize: '14px',
    animation: 'sparkle 4s ease-in-out infinite',
    opacity: 0.8,
  },
  promoSparkle1: {
    top: '8%',
    right: '8%',
    animationDelay: '0s',
  },
  promoSparkle2: {
    bottom: '8%',
    left: '8%',
    animationDelay: '2s',
  },
  comingSoonPlaceholder: {
    width: '100%',
    aspectRatio: '2/3',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    gap: '10px',
  },
  comingSoonIcon: {
    fontSize: '36px',
  },
  comingSoonText: {
    fontSize: '14px',
    fontWeight: '800',
    color: '#FFD700',
    textAlign: 'center',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    textShadow: '0 0 10px rgba(255, 215, 0, 0.6)',
    whiteSpace: 'pre-line',
  },
};

export default PromoComic;
